import { render, staticRenderFns } from "./ActionOpenProposalFullDetails.vue?vue&type=template&id=463a2412&scoped=true&"
import script from "./ActionOpenProposalFullDetails.vue?vue&type=script&lang=js&"
export * from "./ActionOpenProposalFullDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a2412",
  null
  
)

export default component.exports